export const MODULE_ID = 'mobile';
export const PATIENT_SETUP_FORM = `${MODULE_ID}.patientSetupForm`;
export const SELECTABLE_GLUCOSE_UNIT_TYPE_COUNTRY_CODES = [
    'ca',
    'ch'
];
